import { makeFinalFormValidator } from '@readcloud/common';
import { Annotation } from '@readcloud/data';
import React from 'react';
import { Form } from 'react-final-form';
import * as yup from 'yup';
import { Forms } from '../..';
const schema = yup.object(Forms.commonSchemas.commonFields);
const validate = makeFinalFormValidator(schema);

export function CommonDrawingForm(
  props: {
    annotation: Annotation;
    onAnnotationChange: (anno: Annotation) => void;
  } & Pick<
    React.ComponentProps<typeof Forms.commonElements.CommonFields>,
    'showPublisherOptions' | 'showDescription'
  >
) {
  return (
    <Form
      validate={validate}
      onSubmit={(values) =>
        //TODO: Get rid of the any
        props.onAnnotationChange(
          Forms.commonElements.formValuesToAnnotation(
            props.annotation,
            values as any
          )
        )
      }
      initialValues={Forms.commonElements.annotationToFormValues(
        props.annotation
      )}
    >
      {() => (
        <>
          <div className="rc-py-2"></div>
          <div className="rc-flex rc-flex-col">
            <Forms.AutoSubmit enabled />
            <Forms.commonElements.CommonFields
              showDescription={props.showDescription}
              showPublisherOptions={props.showPublisherOptions}
            />
          </div>
        </>
      )}
    </Form>
  );
}
